import React from 'react';

const useWebHookActions = webhook => {
    return React.useMemo(() => {
        if (!webhook) return [];
        return [webhook.active ? 'disable' : 'enable', 'archive', webhook.paused_at ? 'resume' : 'pause'];
    }, [webhook]);
};

export default useWebHookActions;
